import SeoPage from "../components/SeoPage";

export default function Ecommerce() {
  return (
    <SeoPage
      title="Ecommerce Development Company | Arviko"
      description="Build scalable ecommerce platforms with Arviko."
      heading="Ecommerce Development Company"
    >
      <p>
        We create powerful ecommerce platforms for online businesses.
      </p>
    </SeoPage>
  );
}